const items = ["playful banter", "slow burns", "bookshop dates", "tender endings"];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="overflow-hidden border-y border-cocoa/10 bg-butter py-7" data-testid="editorial-marquee" aria-label="Editorial marquee">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {row.map((item, index) => (
              <span key={`${copy}-${item}-${index}`} className="mx-8 whitespace-nowrap font-display text-4xl italic text-cocoa/75 md:text-6xl">
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
